import { Wrench } from "lucide-react";
import { COLORS, RADIUS, SPACE, TYPE } from "../theme/index.js";

interface ToolCallCardProps {
  toolName: string;
  args?: Record<string, unknown>;
  result?: string;
}

export function ToolCallCard({ toolName, args, result }: ToolCallCardProps) {
  return (
    <div
      style={{
        background: COLORS.surface,
        border: `1px solid ${COLORS.border}`,
        borderRadius: RADIUS.md,
        padding: `${SPACE[2]}px ${SPACE[3]}px`,
        fontSize: TYPE.size.xs,
        color: COLORS.textMuted,
        display: "flex",
        flexDirection: "column",
        gap: SPACE[1],
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: SPACE[1] }}>
        <Wrench size={11} style={{ color: COLORS.brandText, flexShrink: 0 }} />
        <span style={{ fontFamily: "'JetBrains Mono', monospace", color: COLORS.brandText }}>
          {toolName}
        </span>
      </div>
      {args && Object.keys(args).length > 0 && (
        <pre
          style={{
            margin: 0,
            fontSize: TYPE.size.xs,
            color: COLORS.textDim,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            fontFamily: "'JetBrains Mono', monospace",
          }}
        >
          {JSON.stringify(args, null, 2)}
        </pre>
      )}
      {result && (
        <div
          style={{
            color: COLORS.textDim,
            borderTop: `1px solid ${COLORS.border}`,
            paddingTop: SPACE[1],
          }}
        >
          {result}
        </div>
      )}
    </div>
  );
}
